import { useMemo } from "react";

export interface VstsSourceSettingsText {
  accountLabelText: string;
  accountHintText: string;
  accountPlaceholderText: string;
  modeLabelText: string;
  boardModeLabel: string;
  boardModeHint: string;
  statusModeLabel: string;
  statusModeHint: string;
  projectLabelText: string;
  projectHintText: string;
  projectPlaceholderText: string;
  teamLabelText: string;
  teamHintText: string;
  teamPlaceholderText: string;
  boardLabelText: string;
  boardHintText: string;
  boardPlaceholderText: string;
  workItemTypeLabelText: string;
  workItemTypeHintText: string;
  workItemTypePlaceholderText: string;
  columnsToLoadLabelText: string;
  columnsToLoadHintText: string;
  columnsToLoadPlaceholderText: string;
  doneColumnLabelText: string;
  doneColumnHintText: string;
  doneColumnPlaceholderText: string;
  assignedToFieldLabelText: string;
  assignedToFieldHintText: string;
  assignedToFieldPlaceholderText: string;
  whenDoneAssignToCreatorLabelText: string;
  whenDoneAssignToCreatorHintText: string;
  includeProjectInTitleLabelText: string;
  includeTypeAcronymInTitleLabelText: string;
  titleOptionsLabelText: string;
  includeParentIdAsTagLabelText: string;
  includeTagsLabelText: string;
  tagOptionsLabelText: string;
  tagsHintText: string;
  statusModeProjectsLabelText: string;
  statusModeProjectsHintText: string;
  statusModeProjectsPlaceholderText: string;
  addWorkItemTypeLabelText: string;
  addWorkItemTypeHintText: string;
  addWorkItemTypePlaceholderText: string;
  statusesToLoadPlaceholderText: string;
  doneStatusPlaceholderText: string;
  loadingText: string;
  loadErrorText: string;
}

export const useVstsSourceSettingsText = (
  t: (key: string) => string,
): VstsSourceSettingsText => {
  return useMemo(() => {
    const tKey = (key: string): string =>
      t(`board.connections.dialog.sourceSettings.vsts.${key}`);

    return {
      accountLabelText: tKey("accountLabel"),
      accountHintText: tKey("accountHint"),
      accountPlaceholderText: tKey("accountPlaceholder"),
      modeLabelText: tKey("modeLabel"),
      boardModeLabel: tKey("boardModeLabel"),
      boardModeHint: tKey("boardModeHint"),
      statusModeLabel: tKey("statusModeLabel"),
      statusModeHint: tKey("statusModeHint"),
      projectLabelText: tKey("projectLabel"),
      projectHintText: tKey("projectHint"),
      projectPlaceholderText: tKey("projectPlaceholder"),
      teamLabelText: tKey("teamLabel"),
      teamHintText: tKey("teamHint"),
      teamPlaceholderText: tKey("teamPlaceholder"),
      boardLabelText: tKey("boardLabel"),
      boardHintText: tKey("boardHint"),
      boardPlaceholderText: tKey("boardPlaceholder"),
      workItemTypeLabelText: tKey("workItemTypeLabel"),
      workItemTypeHintText: tKey("workItemTypeHint"),
      workItemTypePlaceholderText: tKey("workItemTypePlaceholder"),
      columnsToLoadLabelText: tKey("columnsToLoadLabel"),
      columnsToLoadHintText: tKey("columnsToLoadHint"),
      columnsToLoadPlaceholderText: tKey("columnsToLoadPlaceholder"),
      doneColumnLabelText: tKey("doneColumnLabel"),
      doneColumnHintText: tKey("doneColumnHint"),
      doneColumnPlaceholderText: tKey("doneColumnPlaceholder"),
      assignedToFieldLabelText: tKey("assignedToFieldLabel"),
      assignedToFieldHintText: tKey("assignedToFieldHint"),
      assignedToFieldPlaceholderText: tKey("assignedToFieldPlaceholder"),
      whenDoneAssignToCreatorLabelText: tKey("whenDoneAssignToCreatorLabel"),
      whenDoneAssignToCreatorHintText: tKey("whenDoneAssignToCreatorHint"),
      includeProjectInTitleLabelText: tKey("includeProjectInTitleLabel"),
      includeTypeAcronymInTitleLabelText: tKey(
        "includeTypeAcronymInTitleLabel",
      ),
      titleOptionsLabelText: tKey("titleOptionsLabel"),
      includeParentIdAsTagLabelText: tKey("includeParentIdAsTagLabel"),
      includeTagsLabelText: tKey("includeTagsLabel"),
      tagOptionsLabelText: tKey("tagOptionsLabel"),
      tagsHintText: tKey("tagsHint"),
      statusModeProjectsLabelText: tKey("statusModeProjectsLabel"),
      statusModeProjectsHintText: tKey("statusModeProjectsHint"),
      statusModeProjectsPlaceholderText: tKey("statusModeProjectsPlaceholder"),
      addWorkItemTypeLabelText: tKey("addWorkItemTypeLabel"),
      addWorkItemTypeHintText: tKey("addWorkItemTypeHint"),
      addWorkItemTypePlaceholderText: tKey("addWorkItemTypePlaceholder"),
      statusesToLoadPlaceholderText: tKey("statusesToLoadPlaceholder"),
      doneStatusPlaceholderText: tKey("doneStatusPlaceholder"),
      loadingText: tKey("loading"),
      loadErrorText: tKey("loadError"),
    };
  }, [t]);
};
